<template>
  <v-navigation-drawer
    app
    fixed
    clipped
    :temporary="!permanent"
    :permanent="permanent"
    v-model="model"
  >
    <v-list expand class="static-group-headers">
      <template v-if="isAuthAdmin">
        <v-list-tile to="/status">
          <v-list-tile-action>
            <v-icon>verified_user</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/systemStatusLinkText') }}</v-list-tile-title>
        </v-list-tile>

        <v-divider></v-divider>
      </template>

      <v-list subheader>
        <v-subheader>{{ $t('@mainMenu/insuranceSection/headingText') }}</v-subheader>

        <v-list-tile
          to="/contracts/created"
          :class="{
            active: isActiveMenu(ContractStatusEnum.created),
          }"
        >
          <v-list-tile-action>
            <v-icon>inbox</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@mainMenu/insuranceSection/waitingForAcceptanceLinkText') }}
          </v-list-tile-title>
          <v-chip small color="light-green" text-color="white" class="v-chip--x-small">
            {{ counters.insurance.new }}
          </v-chip>
        </v-list-tile>

        <v-list-tile
          to="/contracts/offerAccepted"
          :class="{
            active: isActiveMenu(ContractStatusEnum.offerAccepted),
          }"
        >
          <v-list-tile-action>
            <v-icon>done_all</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@mainMenu/insuranceSection/acceptedLinkText') }}
          </v-list-tile-title>
          <v-chip small color="blue darken-1" text-color="white" class="v-chip--x-small">
            {{ counters.insurance.accepted }}
          </v-chip>
        </v-list-tile>

        <v-list-tile
          to="/contracts/terminated"
          :class="{
            active:
              isActiveMenu(ContractStatusEnum.terminated) ||
              isActiveMenu(ContractStatusEnum.terminating),
          }"
        >
          <v-list-tile-action>
            <v-icon>remove_circle_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@mainMenu/insuranceSection/terminatedLinkText') }}
          </v-list-tile-title>
          <v-chip small color="red darken-2" text-color="white" class="v-chip--x-small">
            {{ counters.insurance.terminated }}
          </v-chip>
        </v-list-tile>

        <v-list-tile
          to="/contracts/toBeTerminated"
          :class="{
            active: isActiveMenu(ContractStatusEnum.toBeTerminated),
          }"
        >
          <v-list-tile-action>
            <v-icon>error_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@insurance/toBeTerminatedStatusLabel') }}</v-list-tile-title>
          <v-chip small color="orange darken-2" text-color="white" class="v-chip--x-small">
            {{ counters.insurance.toBeTerminated }}
          </v-chip>
        </v-list-tile>

        <v-list-tile
          to="/contracts/unpaidPaperInvoice"
          :class="{
            active: isActiveMenu(ContractStatusEnum.unpaidPaperInvoice),
          }"
        >
          <v-list-tile-action>
            <v-icon>error_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@insurance/unpaidPaperInvoiceStatusLabel') }}
          </v-list-tile-title>
          <v-chip small color="orange darken-2" text-color="white" class="v-chip--x-small">
            {{ counters.insurance.unpaid }}
          </v-chip>
        </v-list-tile>

        <v-list-tile to="/customers">
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/customersLinkText') }}</v-list-tile-title>
        </v-list-tile>

        <v-divider></v-divider>
        <v-subheader>{{ $t('@insurance/bankDetails/title') }}</v-subheader>

        <v-list-tile to="/bankdetails/absent">
          <v-list-tile-action>
            <v-icon>inbox</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@insurance/bankDetails/absentStatusLabel') }}
          </v-list-tile-title>
          <v-chip small color="red darken-2" text-color="white" class="v-chip--x-small">
            {{ counters.bankDetails.absent }}
          </v-chip>
        </v-list-tile>

        <v-list-tile to="/bankdetails/new">
          <v-list-tile-action>
            <v-icon>inbox</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@insurance/bankDetails/newStatusLabel') }}</v-list-tile-title>
          <v-chip small color="light-green" text-color="white" class="v-chip--x-small">
            {{ counters.bankDetails.new }}
          </v-chip>
        </v-list-tile>

        <v-list-tile to="/bankdetails/pending">
          <v-list-tile-action>
            <v-icon>access_time</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@insurance/bankDetails/pendingStatusLabel') }}
          </v-list-tile-title>
          <v-chip small color="light-green" text-color="white" class="v-chip--x-small">
            {{ counters.bankDetails.pending }}
          </v-chip>
        </v-list-tile>

        <v-list-tile to="/bankdetails/approved">
          <v-list-tile-action>
            <v-icon>done_all</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@insurance/bankDetails/approvedStatusLabel') }}
          </v-list-tile-title>
          <v-chip small color="blue darken-1" text-color="white" class="v-chip--x-small">
            {{ counters.bankDetails.approved }}
          </v-chip>
        </v-list-tile>

        <v-list-tile to="/bankdetails/declined">
          <v-list-tile-action>
            <v-icon>remove_circle_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@insurance/bankDetails/declinedStatusLabel') }}
          </v-list-tile-title>
          <v-chip small color="red darken-2" text-color="white" class="v-chip--x-small">
            {{ counters.bankDetails.declined }}
          </v-chip>
        </v-list-tile>

        <!-- INSURANCE-528: Temporarily commented until better UX will be imlemented for them -->
        <!--
        <v-list-tile to="/invoices">
          <v-list-tile-action>
            <v-icon>attach_money</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/invoicesLinkText') }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile to="/debts">
          <v-list-tile-action>
            <v-icon>schedule</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/debtsLinkText') }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile disabled to="/stats">
          <v-list-tile-action>
            <v-icon>timeline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/statisticsLinkText') }}</v-list-tile-title>
        </v-list-tile>
        -->
      </v-list>

      <v-divider></v-divider>
      <v-list v-if="isAuthAdmin || isCompanyAgent" subheader>
        <v-subheader>{{ $t('@mainMenu/adminSection/headingText') }}</v-subheader>

        <v-list-tile to="/periods" v-if="isAuthAdmin">
          <v-list-tile-action>
            <v-icon>event_available</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/billingPeriodsLinkText') }}</v-list-tile-title>
        </v-list-tile>

        <!-- INSURANCE-562 -->
        <!-- Temporarily hidden -->
        <!-- <v-list-tile to="/bgc">
          <v-list-tile-action>
            <v-icon>description</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>BGC Filer</v-list-tile-title>
        </v-list-tile>-->

        <v-list-tile to="/reports">
          <v-list-tile-action>
            <v-icon>assignment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('@mainMenu/adminSection/reportsLinkText') }}</v-list-tile-title>
        </v-list-tile>

        <!-- This is commented as we dont have role based check -->
        <!-- <v-list-tile to="/billing-dashboard">
          <v-list-tile-action>
            <v-icon>assignment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@mainMenu/adminSection/revenueDashboardLinkText') }}
          </v-list-tile-title>
        </v-list-tile> -->

        <!-- INSURANCE-528: Disable pdf templates due to bad UX -->
        <!--
        <v-list-tile to="/pdf">
          <v-list-tile-action>
            <v-icon>print</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>PDF Templates</v-list-tile-title>
        </v-list-tile>
        -->

        <v-list-tile to="/campaigns" v-if="isAuthAdmin">
          <v-list-tile-action>
            <v-icon>discount</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@mainMenu/adminSection/campaignsLinkText') }}
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile to="/repayments" v-if="isAuthAdmin">
          <v-list-tile-action>
            <v-icon>attach_money</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('@mainMenu/adminSection/repaymentsLinkText') }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>

      <v-divider />

      <mock-time v-if="showTimeMock"></mock-time>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { ContractStatusEnum } from '../constants';
import MockTime from './MockTime.vue';

export default {
  components: {
    MockTime,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    permanent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      insurance: true,
      model: this.$props.value,
      ContractStatusEnum,
    };
  },

  watch: {
    value(val) {
      this.model = val;
    },

    model(val) {
      this.$emit('input', val);
    },
  },

  methods: {
    isActiveMenu(el) {
      return this.contractStatus === el;
    },
  },

  computed: {
    ...mapState({
      counters: (state) => state.stat.counters,
      contractStatus: (state) => state.stat.contractStatus,
    }),
    ...mapGetters(['isAuthAdmin', 'isCompanyAgent']),

    showTimeMock() {
      if (process.env.VUE_APP_SHOW_TIME_MOCK === 'true') {
        return true;
      }

      return false;
    },
  },

  created() {
    this.$store.dispatch('updateCounters');
  },
};
</script>

<style scoped>
.v-chip--x-small {
  font-size: 12px;
  height: 20px !important;
}

.v-chip--x-small >>> .v-chip__content {
  line-height: 1;
  padding: 8px;
  justify-content: center;
  min-width: 36px;
}

.static-group-headers >>> .v-list__group__header {
  pointer-events: none;
}

>>> .v-list__tile--active,
>>> .active > .v-list__tile {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
